import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { motion } from 'framer-motion';
import Header from './components/Header';
import Footer from './components/Footer';
import GoogleAnalytics from './components/GoogleAnalytics';
import Home from './pages/Home';
import Pricing from './pages/Pricing';
import AgentSRE from './pages/AgentSRE';
import AIAlerting from './pages/AIAlerting';
import Security from './pages/Security';
import AIOps from './pages/AIOps';
import Contact from './pages/Contact';
import Demo from './pages/Demo';
import About from './pages/About';
import Careers from './pages/Careers';
import Blog from './pages/Blog';
import APM from './pages/APM';
import LogManagement from './pages/LogManagement';
import InfrastructureMonitoring from './pages/InfrastructureMonitoring';
import RCAAgent from './pages/RCAAgent';
import B2BSuccessAgent from './pages/B2BSuccessAgent';
import AdvancedAIOps from './pages/AdvancedAIOps';
import AgenticDatabase from './pages/AgenticDatabase';
import ObservabilityPlatform from './pages/ObservabilityPlatform';
import AIMonitoring from './pages/AIMonitoring';
import CloudMonitoring from './pages/CloudMonitoring';
import DevOpsObservability from './pages/DevOpsObservability';
import LogCrestVsDatadog from './pages/LogCrestVsDatadog';
import LogCrestVsSplunk from './pages/LogCrestVsSplunk';
import LogCrestVsNewRelic from './pages/LogCrestVsNewRelic';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import FAQs from './pages/FAQs';
import './App.css';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <GoogleAnalytics />
          <Header />
          <motion.main
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
          >
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/agent-sre" element={<AgentSRE />} />
              <Route path="/ai-alerting" element={<AIAlerting />} />
              <Route path="/security" element={<Security />} />
              <Route path="/ai-ops" element={<AIOps />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/demo" element={<Demo />} />
              <Route path="/about" element={<About />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/apm" element={<APM />} />
              <Route path="/log-management" element={<LogManagement />} />
              <Route path="/infrastructure-monitoring" element={<InfrastructureMonitoring />} />
              <Route path="/rca-agent" element={<RCAAgent />} />
              <Route path="/b2b-success-agent" element={<B2BSuccessAgent />} />
              <Route path="/advanced-aiops" element={<AdvancedAIOps />} />
              <Route path="/agentic-database" element={<AgenticDatabase />} />
              <Route path="/observability-platform" element={<ObservabilityPlatform />} />
              <Route path="/ai-monitoring" element={<AIMonitoring />} />
              <Route path="/cloud-monitoring" element={<CloudMonitoring />} />
              <Route path="/devops-observability" element={<DevOpsObservability />} />
              <Route path="/logcrest-vs-datadog" element={<LogCrestVsDatadog />} />
              <Route path="/logcrest-vs-splunk" element={<LogCrestVsSplunk />} />
              <Route path="/logcrest-vs-newrelic" element={<LogCrestVsNewRelic />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/faqs" element={<FAQs />} />
            </Routes>
          </motion.main>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;